import { Locale } from '../../../types';
import { FlightStatusConfigError } from './Errors';
export class MapConfigImpl {
    constructor(config) {
        this.center = config.center;
        this._stylesRu = config.stylesRu;
        this._stylesEn = config.stylesEn;
        this.accessToken = config.accessToken;
        this.locale = config.locale;
        this.container = config.container;
        this.selectedAirportOverlayContainer = config.selectedAirportOverlayContainer;
        this.hoverAirportOverlayContainer = config.hoverAirportOverlayContainer;
        this.flightOverlayContainer = config.flightOverlayContainer;
        this.isMobileMode = config.isMobileMode;
        this.iata = config.iata;
    }
    get style() {
        return this.locale === Locale.Russian ? this._stylesRu : this._stylesEn;
    }
    get aircraftActive() {
        if (this.isZZ) {
            return require('../icons/activeAircraft.svg');
        }
        return require(`../icons/activeAircraft_${this.iata}.svg`);
    }
    get aircraft() {
        if (this.isZZ) {
            return require('../icons/aircraft.svg');
        }
        return require(`../icons/aircraft_${this.iata}.svg`);
    }
    get city() {
        if (this.isZZ) {
            return require('../icons/city.svg');
        }
        return require(`../icons/city_${this.iata}.svg`);
    }
    get cityActive() {
        if (this.isZZ) {
            return require('../icons/cityActive.svg');
        }
        return require(`../icons/cityActive_${this.iata}.svg`);
    }
    get routeColor() {
        switch (this.iata) {
            case 'ZZ':
                return '#3290ff';
            case 'DV':
                return '#143f87';
            default:
                throw new FlightStatusConfigError(`provide color for current iata ${this.iata}`);
        }
    }
    get isZZ() {
        return this.iata === 'ZZ';
    }
}
